/** Escapes a value for use inside an HTML string (text or a double-quoted attribute). */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * HTML for an `aw-table` custom cell: a name link with an optional line of subtext beneath it. Uses `aw-table`'s own
 * `.link` and `.sub-title` cell classes so the colours come from CCL tokens. Values come from the API, so they're escaped.
 */
export function linkCellTemplate(name: unknown, href: unknown, subtitle?: unknown): string {
  const sub = subtitle === undefined ? '' : `<p class="sub-title">${escapeHtml(subtitle)}</p>`;
  return `<div class="custom-template"><a class="link" href="${escapeHtml(href)}">${escapeHtml(name)}</a>${sub}</div>`;
}
